export default {
   //   BASE_URL: 'https://dev.semutgajah.com'
   //   BASE_URL: 'https://staging.semutgajah.com'
   //   BASE_URL: 'https://production.semutgajah.com'
     BASE_URL: 'https://distributor.semutgajah.com'
  };